import { useRootStore } from 'stores/RootStore'

export const useDecisionModeStore = () => {
  const rootStore = useRootStore()
  return rootStore.docStore?.decisionModeStore
}
